import { useStoryblok } from '$lib/storyblok';
import { cachedUrls } from '$lib/stores.js';
import { get } from 'svelte/store';

export async function load({ data, platform }) {
	await useStoryblok();
	cachedUrls.set(data.storyUrls);

	return {
		story: data.story,
		href: data.href
	};
}
